/* src/app/components/analytics/facts-and-issues/facts-timeline/facts-timeline.component.scss */
.main-container {
  display: flex;
  flex-direction: column;
}
.label-control-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 30px;
  margin-bottom: 30px;
  margin-right: 5px;
  gap: 20px;
}
.collapsed-timeline-ruler {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.timeline-ruler {
  display: flex;
  flex-direction: row;
}
.timeline-year {
  transition: 0.5s ease-in-out;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
}
.timeline-container {
  display: flex;
  flex-direction: column;
  transition: 0.5s ease-in-out;
}
.timeline-row {
  display: flex;
  flex-direction: row;
  height: 80px;
  transition: 0.5s ease-in-out;
}
.timeline-row .timeline-cell {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  align-content: stretch;
  text-align: center;
  min-width: 90px;
  transition: 0.5s ease-in-out;
}
.timeline-row .timeline-cell.empty {
  min-width: initial;
}
.timeline-row .timeline-cell .timeline-cell-content {
  border: 1px solid #3949AB;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
}
.timeline-row .timeline-cell .timeline-cell-content .timeline-cell-content-header {
  background: #3f51b5;
  padding: 5px;
  color: #FFF;
}
.timeline-row .timeline-cell .timeline-cell-content .timeline-fact {
  display: flex;
  flex: 1 1 100%;
  align-items: center;
  justify-content: center;
  margin: 4px;
  overflow: hidden;
  font-weight: 500;
  height: 38px;
  box-sizing: border-box;
  padding: 10px 5px;
}
.line.arrow-right:after {
  position: absolute;
  content: "";
  bottom: -4px;
  right: 0;
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 5px solid #3c3c3c;
}
:host-context(.dark-theme) hr {
  border: 1px solid #949494;
}
:host-context(.dark-theme) .line.arrow-right:after {
  border-left-color: #949494;
}
:host-context(.dark-theme) .timeline-cell-content {
  background-color: #464646;
}
/*# sourceMappingURL=facts-timeline.component.css.map */
